"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var react_1 = __importDefault(require("react"));
var theme_1 = require("../theme");
var baseSize = 20;
exports.Icon = react_1.default.memo(function (props) {
    var icon = props.icon, _a = props.size, size = _a === void 0 ? baseSize : _a, viewBox = props.viewBox, active = props.active, svgProps = __rest(props, ["icon", "size", "viewBox", "active"]);
    var fill = theme_1.theme.colors[active ? icon.activeColor : icon.basicColor];
    var vbx = (icon.originalWidth - baseSize) / 2;
    var vby = (icon.originalHeight - baseSize) / 2;
    return (react_1.default.createElement("svg", __assign({}, svgProps, { width: size, height: size, viewBox: viewBox || "".concat(vbx, " ").concat(vby, " ").concat(baseSize, " ").concat(baseSize), fill: "none", xmlns: "http://www.w3.org/2000/svg" }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: icon.path, fill: fill })));
});
